import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './views/dashboard/dashboard.component';
import {ContentComponent} from './views/content/content.component';
import {UsersComponent} from './views/users/users.component';
import {UserComponent} from './views/users/user/user.component';
import {ErrorPageComponent} from './views/error-page/error-page.component';
import {ContentViewComponent} from './views/content/content-view/content-view.component';
import {CreateUserComponent} from './views/users/create-user/create-user.component';
import {UserEditComponent} from './views/users/user-edit/user-edit.component';
import {HomeComponent} from './views/home/home.component';
import {ReportsComponent} from './views/reports/reports.component';
import {LandingComponent} from './views/landing/landing.component';
import {
  BuilderFormComponent,
  TemplateEditMode,
} from './views/builder/builder-form/builder-form.component';
import {BuilderOverviewComponent} from './views/builder/builder-overview/builder-overview.component';
import {TemplatesComponent} from './views/templates/templates.component';
import {TemplateOverviewComponent} from './views/templates/template-overview/template-overview.component';
import {TemplateDetailsComponent} from './views/templates/template-details/template-details.component';
import {BuilderComponent} from './views/builder/builder.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {path: 'dashboard', component: DashboardComponent},
      {
        path: 'templates',
        component: TemplatesComponent,
        children: [
          {path: 'overview', component: TemplateOverviewComponent},
          {path: 'details/:id', component: TemplateDetailsComponent},
          {
            path: `${TemplateEditMode.EDIT}/:id`,
            component: BuilderFormComponent,
            data: {hideHeader: true},
          },
          {path: '', pathMatch: 'full', redirectTo: 'overview'},
        ],
      },
      {path: 'content', component: ContentComponent},
      {path: 'content/:id', component: ContentViewComponent},
      {path: 'reports', component: ReportsComponent},
      {path: 'users', component: UsersComponent},
      {path: 'user/:id', component: UserComponent},
      {path: 'create-user', component: CreateUserComponent},
      {path: 'edit-user/:id', component: UserEditComponent},
      {
        path: 'builder',
        component: BuilderComponent,
        children: [
          {path: 'overview', component: BuilderOverviewComponent},
          {
            path: `${TemplateEditMode.NEW}/:id`,
            component: BuilderFormComponent,
            data: {hideHeader: true},
          },
          {path: '', pathMatch: 'full', redirectTo: 'overview'},
        ],
      },
    ],
  },
  {path: 'view-content/:lookup_id/:type/:hash', component: LandingComponent},
  {path: 'not-found', component: ErrorPageComponent, data: {message: 'Page not found!'}},
  {path: '**', redirectTo: '/not-found'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
